// Libs
import React from "react";
import { useQueryParam, StringParam } from "use-query-params";

// Components
import { Dropdown } from "../../spocketUI";

// Images
import iconExpand from "../../images/icon-expand.svg";

// Style
import { StyledButton, Label, Title, Description, Icon } from "./SortByStyle";

// i18n
import { useTranslation } from 'react-i18next';

const SortBy = () => {
  const { t } = useTranslation();
  const [sortBy, setSortBy] = useQueryParam("sort_by", StringParam);

  const getSelectedSortByDescription = () => {
    switch(sortBy){
      case "low-to-high":
        return t("SortBy.DropDown.Item.PriceLowToHigh");
      case "high-to-low":
        return t("SortBy.DropDown.Item.PriceHighToLow");
      case "newest":
        return t("SortBy.DropDown.Item.Newest");
      case "shipping-time":
        return t("SortBy.DropDown.Item.ShippingTime");
      default: return t("SortBy.DropDown.Item.Relevance");
    }
  };
  return (
    <Dropdown position="right">
      <Dropdown.Trigger>
        <StyledButton>
          <Label>
            <Title>{ t("SortBy.Label.SortBy") }</Title>
            <Description>
              {getSelectedSortByDescription()}
            </Description>
          </Label>
          <Icon src={iconExpand} alt="expand" />
        </StyledButton>
      </Dropdown.Trigger>
      <Dropdown.Content>
        <Dropdown.Item
          checked={!sortBy}
          onClick={() => setSortBy(null, "pushIn")}
        >
          { t("SortBy.DropDown.Item.Relevance") }
        </Dropdown.Item>
        <Dropdown.Item
          checked={sortBy === "low-to-high"}
          onClick={() => setSortBy("low-to-high", "pushIn")}
        >
          { t("SortBy.DropDown.Item.PriceLowToHigh") }
        </Dropdown.Item>
        <Dropdown.Item
          checked={sortBy === "high-to-low"}
          onClick={() => setSortBy("high-to-low", "pushIn")}
        >
          { t("SortBy.DropDown.Item.PriceHighToLow") }
        </Dropdown.Item>
        <Dropdown.Item
          checked={sortBy === "newest"}
          onClick={() => setSortBy("newest", "pushIn")}
        >
          { t("SortBy.DropDown.Item.Newest") }
        </Dropdown.Item>
        <Dropdown.Item
          checked={sortBy === "shipping-time"}
          onClick={() => setSortBy("shipping-time", "pushIn")}
        >
          { t("SortBy.DropDown.Item.ShippingTime") }
        </Dropdown.Item>
      </Dropdown.Content>
    </Dropdown>
  );
};

export default SortBy;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/SortBy.js